import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { apiPaths } from '../../../../../service/apiPaths';
import ApiService from '../../../../../service/ApiService';
import { IAddClient } from '../../Client.props';

const useAddClient = () => {
  const [formData, setFormData] = useState<IAddClient>({
    name: "",
    email: "",
    phone: "",
    companyName: "",
    description: "",
    status: "Active",
    linkedin: "",
    interest: "",
    outputStatus: "",
    services: "",
    platform: "",
  });
  const [interest, setInterest] = useState<any[]>([]);
  const [interestId, setInterestId] = useState<string>("");
  const [services, setServices] = useState<any[]>([]);
  const [serviceId, setServiceId] = useState<string>("");
  const [outputStatuses, setOutputStatuses] = useState<any[]>([]);
  const [outputStatusId, setOutputStatusId] = useState<string>("");
  const [platforms, setPlatforms] = useState<any[]>([]);
  const [platformId, setPlatformId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  useEffect(() => {
    fetchInterestsData();
    fetchServicesData();
    fetchOutputStatusesData();
    fetchPlatformsData();
  }, []);

  const fetchInterestsData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.interests}`,
      });
      setInterest(result);
      setInterestId(result[0].id);
    } catch (error) {
      console.error("Error fetching interests:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchServicesData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.services}`,
      });
      setServices(result);
      setServiceId(result[0].id);
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOutputStatusesData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.outputStatus}`,
      });
      setOutputStatuses(result);
      setOutputStatusId(result[0].id);
    } catch (error) {
      console.error("Error fetching output statuses:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPlatformsData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.platforms}`,
      });
      setPlatforms(result);
      setPlatformId(result[0].id);
    } catch (error) {
      console.error("Error fetching platforms:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, value, name } = e.target;
    setFormData({ ...formData, [id || name]: value });
  };

  const handleSubmit: SubmitHandler<IAddClient> = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.createClient,
        data: {
          ...formData,
          interest: interestId,
          outputStatus: outputStatusId,
          services: serviceId,
          platform: platformId,
          isClient: true
        },
      });
      if (response !== "undefined") {
        toast.success("Client added successfully", {
          duration: 5000,
        });
        setTimeout(() => {
          navigate("/client");
        }, 1500);
      }
    } catch (error) {
      toast.error(`Error - ${error}`, {
        duration: 5000,
      });
      console.error("Error adding client:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/client");
  };

  return {
    loading,
    formData,
    handleChange,
    handleSubmit,
    handleCancel,
    setInterestId,
    interest,
    interestId,
    services,
    serviceId,
    setServiceId,
    outputStatuses,
    outputStatusId,
    setOutputStatusId,
    platforms,
    platformId,
    setPlatformId,
  };
};

export default useAddClient;
